'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'calendar-xmark';
var width = 448;
var height = 512;
var aliases = ["calendar-times"];
var unicode = 'f273';
var svgPathData = ['M448 464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192H448V464zM304.1 304.1C314.3 295.6 314.3 280.4 304.1 271C295.6 261.7 280.4 261.7 271 271L224 318.1L176.1 271C167.6 261.7 152.4 261.7 143 271C133.7 280.4 133.7 295.6 143 304.1L190.1 352L143 399C133.7 408.4 133.7 423.6 143 432.1C152.4 442.3 167.6 442.3 176.1 432.1L224 385.9L271 432.1C280.4 442.3 295.6 442.3 304.1 432.1C314.3 423.6 314.3 408.4 304.1 399L257.9 352L304.1 304.1z', 'M160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V192H0V112C0 85.49 21.49 64 48 64H96V32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32zM257.9 352L304.1 399C314.3 408.4 314.3 423.6 304.1 432.1C295.6 442.3 280.4 442.3 271 432.1L224 385.9L176.1 432.1C167.6 442.3 152.4 442.3 143 432.1C133.7 423.6 133.7 408.4 143 399L190.1 352L143 304.1C133.7 295.6 133.7 280.4 143 271C152.4 261.7 167.6 261.7 176.1 271L224 318.1L271 271C280.4 261.7 295.6 261.7 304.1 271C314.3 280.4 314.3 295.6 304.1 304.1L257.9 352z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCalendarXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;